import { render } from "./ModalDiagnosticar.vue?vue&type=template&id=2f0326a1&scoped=true"
import script from "./ModalDiagnosticar.vue?vue&type=script&lang=js"
export * from "./ModalDiagnosticar.vue?vue&type=script&lang=js"

import "./ModalDiagnosticar.vue?vue&type=style&index=0&id=2f0326a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0326a1"]])

export default __exports__